export default [
  {
    name: 'Tutorial',
    taskDesktop: 'Nutzen Sie die Maus und die Tasten W, A, S, D um die Sonde zu steuern. Für weitere Informationen, nutzen sie die Hilfe. Wenn Sie sich mit der Steuerung vertraut gemacht haben, drücken Sie auf Start.',
    taskTouch: 'Wenn Sie sich mit der Steuerung vertraut gemacht haben, drücken Sie auf Start.',
    rounds: [
      {
        // vollständig
        stackPath: 'tutorial.dcm',
        tutorial: true,
        gameType: 'COLOR',
        solutionType: 'NONE',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          cube: {
            scale: 18.5,
            x: 64,
            y: 32,
            z: 58.5
          },
          cylinder: {
            scale: 18.5,
            x: 74.5,
            y: 48.5,
            z: 31.8
          },
          sphere: {
            scale: 18.5,
            x: 33.5,
            y: 37.3,
            z: 64.5
          }
        }
      }
    ]
  },
  {
    name: 'Spiel 1',
    taskDesktop: 'Welche der Strukturen auf der rechten Seite befindet sich in der kugel? Klicken Sie auf die entsprechende Lösung.',
    taskTouch: 'Welche der Strukturen über der Sonde befindet sich in der kugel? Klicken Sie auf die entsprechende Lösung.',
    rounds: [
      {
        // vollständig
        stackPath: 'volume1.dcm',
        tutorial: false,
        gameType: 'COLOR',
        solutionType: '3DVIEW',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          cube: {
            scale: 18.5,
            x: 60,
            y: 63,
            z: 53
          },
          cylinder: {
            scale: 18.5,
            x: 37,
            y: 43,
            z: 34
          },
          sphere: {
            scale: 18.5,
            x: 49,
            y: 53,
            z: 31
          }
        }
      },
      {
        // vollständig
        stackPath: 'volume13g.dcm',
        tutorial: false,
        gameType: 'GRAY',
        solutionType: '3DVIEW',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          cube: {
            scale: 18.5,
            x: 64,
            y: 72,
            z: 36
          },
          cylinder: {
            scale: 18.5,
            x: 55,
            y: 63,
            z: 39
          },
          sphere: {
            scale: 18.5,
            x: 49,
            y: 46,
            z: 31
          }
        }
      },
      {
        // vollständig
        stackPath: 'volume14k.dcm',
        tutorial: false,
        gameType: 'OUTLINE',
        solutionType: '3DVIEW',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          cube: {
            scale: 18.5,
            x: 49,
            y: 36,
            z: 54
          },
          cylinder: {
            scale: 18.5,
            x: 36,
            y: 52,
            z: 42
          },
          sphere: {
            scale: 18.5,
            x: 54,
            y: 26,
            z: 55
          }
        }
      }
    ]
  },
  {
    name: 'Spiel 2',
    taskDesktop: 'Welche der Schnittbilder auf der rechten Seite befindet sich in der kugel? Klicken Sie auf die entsprechende Lösung.',
    taskTouch: 'Welche der Schnittbilder über der Sonde befindet sich in der kugel? Klicken Sie auf die entsprechende Lösung.',
    rounds: [
      {
        // vollständig
        stackPath: 'volume15.dcm',
        tutorial: false,
        gameType: 'COLOR',
        solutionType: 'SLICE',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          solutionImagePath: 'volume15.png'
        },
        allSolutionImagePaths: [
          'volume0.png',
          'volume0_2.png',
          'volume1.png',
          'volume13.png',
          'volume14.png'
        ]
      },
      {
        // vollständig
        stackPath: 'volume7g.dcm',
        tutorial: false,
        gameType: 'GRAY',
        solutionType: 'SLICE',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          solutionImagePath: 'volume7g.png'
        },
        allSolutionImagePaths: [
          'volume3g.png',
          'volume3g_2.png',
          'volume8g.png',
          'volume4g.png',
          'volume4g_2.png'
        ]
      },
      {
        // vollständig
        stackPath: 'volume2k.dcm',
        tutorial: false,
        gameType: 'OUTLINE',
        solutionType: 'SLICE',
        correctSolution: {
          solutionNumber: Math.floor(Math.random() * Math.floor(4)) + 1,
          solutionImagePath: 'volume2k.png'
        },
        allSolutionImagePaths: [
          'volume3k.png',
          'volume3k_2.png',
          'volume9k.png',
          'volume10k.png',
          'volume13k.png',
          'volume14k.png'
        ]
      }
    ]
  }
]
